import { BaseJsStepAction } from './baseJsStepAction';

export class JsCodeStepAction extends BaseJsStepAction {
    protected isFailedResult(resultValue: any) {
        return resultValue === false;
    }
}
